<template>
	<div style="margin-top: 0px;">
		<!-- 页头 -->
		<roheader></roheader>
		<!-- 内容 -->
		<div style="width:100%;background: #F1F1F1;overflow: auto;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<!-- 左侧菜单 -->
				<rosidebar :selected_page='selected_page'></rosidebar>
				<!-- 微信支付提示弹出页面 -->
				<el-dialog title="微信支付" :visible.sync="wxpay_dialogVisible" width="40%" :before-close="handleClose">
					<el-tabs v-model="payName" type="card">						
						<div style="overflow: hidden;width:85%;margin:20px auto;">
							<el-result icon="success" :title="order_pay_title" style="float:left;overflow: hidden;width: 50%;">
								<template slot="extra" style="color:black;font-weight: 500;">
									<div style="font-size: 20rpx;">
										<span style="float:left">支付方式：</span>
										<span style="float:right">微信收银</span>
									</div>
									<div style="font-size: 20rpx;">
										<span style="float:left">支付金额：</span>
										<span style="color: red;float:right;font-weight: 500;">¥{{total_fees}}元</span>
									</div>
								</template>
							</el-result>
							<!-- v-loading：这是一个自定义指令或组件的标识，用于触发加载状态的显示。
							="loading"：这里的loading是一个Vue实例中定义的响应式数据属性。它的值（通常是布尔类型）决定了加载状态是否应该被显示。
							当loading为true时，加载效果（如遮罩层、加载动画等）会显示在绑定的元素上；当loading为false时，加载效果会隐藏。 -->
							<div v-loading="loading" style="float:right;overflow: hidden;width: 50%;">
								<p>{{ prompt1 }}{{ countdown }}{{ prompt2 }}</p>	
								<img style="height: 100px;" :src='wx_pay_img'  />								
							</div>
						</div>						
						<div style="width:85%;margin: auto;">
							<el-button type="primary" style="width: 200px;margin-bottom: 5%; float: right;margin-right:calc( 25% - 100px );" @click="handleClose">退出</el-button>
						</div>
					</el-tabs>
				</el-dialog>
				
				<!-- 支付宝支付提示弹出页面 -->
				<el-dialog title="支付宝支付" :visible.sync="alipay_dialogVisible" width="40%" :before-close="handleClose">
					<el-tabs v-model="payName" type="card">								
						<div style="overflow: hidden;width:85%;margin:20px auto;">
							<el-result icon="success" :title="order_pay_title" style="float:left;overflow: hidden;width: 50%;">
								<template slot="extra" style="color:black;font-weight: 500;">
									<div style="font-size: 20rpx;">
										<span style="float:left">支付方式：</span>
										<span style="float:right">支付宝</span>
									</div>
									<div style="font-size: 20rpx;">
										<span style="float:left">支付金额：</span>
										<span style="color: red;float:right;font-weight: 500;">¥{{total_fees}}元</span>
									</div>
								</template>
							</el-result>
							<div v-loading="loading" style="float:right;overflow: hidden;width: 50%;text-align: center;">
								<p>{{ prompt1 }}{{ countdown }}{{ prompt3 }}</p>
								<iframe style="width:110px;height:110px;display: inline-block; margin-top: 10px;" :src='ali_pay_img'></iframe>								
							</div>
						</div>
						<div style="width:85%;margin: auto;">
							<el-button type="primary" style="width: 200px;margin-bottom: 5%; float: right;margin-right:calc( 25% - 100px );" @click="handleClose">退出</el-button>
						</div>
					</el-tabs>
				</el-dialog>				
                
				<div style="float: right;width:calc(100% - 269px);;background: white;">
					<div style="width: 90%;margin:20px auto;">
						<el-steps :active="activePage" finish-status="success" simple style="margin-top: 20px">
							<el-step title="填写基本信息" icon="el-icon-edit"></el-step>
							<el-step title="填写查新内容" icon="el-icon-edit"></el-step>
							<el-step title="支付" icon="el-icon-edit"></el-step>
						</el-steps>
					</div>
					<!-- 第一页 填写基本信息 -->
					<div v-if="this.activePage == 0" style="width: 90%;margin:20px auto;background-color: #F0F0F0;padding:10px;">
						<div style="font-size: 12px;">温馨提示：带<span style="color:red;">*</span>的是必填项</div>
						<div v-if='approval_note' style="background-color: #fcdede;padding:0 15px;color:black;float: left;text-align: left;margin-bottom: 10px;;padding: 20px;width: 100%;">
							<div>您的申请资料未通过审核，请查看原因并重新提交：</div>
							<div style="font-weight: bold;">{{approval_note}}</div>
						</div>						
						<el-form :model="form_setp_1" ref="form_setp_1" :rules="form_setp_1_rules" label-width="100px" class="demo-ruleForm" style="padding:10px;">			
							<div style="width:100%;border:2px dotted #cdcdcd;padding:20px;overflow: hidden;">
								<el-radio-group v-model="address_selected" style="width: 100%;"
									@change="select_address($event)">
									<el-radio border class="ro-address-radio"
										v-for="(address_data, index) in address_datas" :key="index"
										:label="address_data.name">
										<span style="width: 100%;"
											:data-id="address_data.id">{{address_data.contact}}</span>
										<div style="width: 100%;" :data-id="address_data.id" class="ro-box-content">
											{{address_data.address}}，{{address_data.contact_mobile}}
										</div>
									</el-radio>
								</el-radio-group>
								<el-row>
									<!-- <a > -->
									<el-button @click="turn_to_new_info"
										style="margin-top: 20px;background: red;color:white;">新增个人信息
									</el-button>
									<!-- </a> -->
								</el-row>
							</div>
							<el-form-item label="单位名称" prop="unit_name" style="margin-top: 30px;">
								<el-input v-model="form_setp_1.unit_name"></el-input>
							</el-form-item>
							<div style="overflow: hidden;">
								<el-form-item label="通讯地址" prop="address" style="float: left;width: 60%;">
									<el-cascader style="width: 100%;" size="large" :options="AreaOptions" v-model="selectedArea" @change="handleChangeArea"></el-cascader>
								</el-form-item>
								<el-form-item label="邮编" prop="postcode" style="float: right;width: 40%;">
									<el-input v-model="form_setp_1.postcode"></el-input>
								</el-form-item>

							</div>
							<div style="overflow: hidden;">
								<el-form-item label="详细地址" prop="address" style="float: left;width: 60%;">
									<el-input v-model="form_setp_1.address"></el-input>
								</el-form-item>

							</div>
							<div style="overflow: hidden;">
								<el-form-item label="委托人" prop="contact" style="float: left;width: 50%;">
									<el-input v-model="form_setp_1.contact"></el-input>
								</el-form-item>
								<el-form-item label="手机" prop="contact_mobile" style="float: left;width: 50%;">
									<el-input v-model="form_setp_1.contact_mobile"></el-input>
								</el-form-item>

							</div>
							<div style="overflow: hidden;">
								<el-form-item label="邮箱" prop="email" style="float: left;width: 50%;">
									<el-input v-model="form_setp_1.email"></el-input>
								</el-form-item>
								<el-form-item label="座机" prop="contact_phone" style="float: left;width: 50%;">
									<el-input v-model="form_setp_1.contact_phone"></el-input>
								</el-form-item>
							</div>

							<el-form-item style="margin-top: 85px;">
								<el-button type="primary" style='margin-left: -95px;' @click="create_kjcx(next=true)">保存并下一步</el-button>
								<el-button type="" @click="create_kjcx(next=false)">保存并退出</el-button>
							</el-form-item>
						</el-form>

					</div>
					<!-- 填写查新内容 -->
					<div v-if="this.activePage == 1" v-loading="file_loading" style="width: 90%;margin:20px auto;padding:5% 1%;background-color: #F0F0F0;overflow: auto;">
						<div v-if='approval_note' style="background-color: #fcdede;padding:0 15px;color:black;float: left;margin-bottom: 10px;margin-top:-30px;padding: 20px;width: 100%;">
							<div>您的申请资料未通过审核，请查看原因并重新提交：</div>
							<div style="font-weight: bold;">{{approval_note}}</div>
						</div>						

						<el-form label-width="95px" class="demo-ruleForm" :model="form_setp_2" :rules="form_setp_2_rules" ref="form_setp_2" label-position="left">
							<el-form-item prop='name' label="项目名称">
								<el-input v-model="form_setp_2.name"></el-input>
							</el-form-item>
							<el-form-item prop='en_name' label="英文名称">
								<el-input v-model="form_setp_2.en_name" placeholder="国内外检索需填写，国内检索无需填写"> </el-input>
							</el-form-item>
							<el-collapse v-model="activeNames">
								<el-collapse-item title="一、查新范围" name="1">
									<el-form-item label="查新范围:" style='margin-top: 24px;' prop="scope">
										<div style="float: left;">
											<el-radio v-model="form_setp_2.scope" label="home">国内</el-radio>
											<el-radio v-model="form_setp_2.scope" label="home_and_abroad">国内外</el-radio>
										</div>
									</el-form-item>
									<el-form-item label="课题级别:" prop="topic_type">
										<div style="float: left;">
											<el-radio v-model="form_setp_2.topic_type" label="national">国家级</el-radio>
											<el-radio v-model="form_setp_2.topic_type" label="state">自治区级</el-radio>
											<el-radio v-model="form_setp_2.topic_type" label="city">盟市级</el-radio>
											<el-radio v-model="form_setp_2.topic_type" label="campus">院内（校内）</el-radio>
										</div>
									</el-form-item>

									<el-form-item label="项目类型:" prop="project_type">
										<div style="float: left;">
											<el-radio v-model="form_setp_2.project_type" label="project">科研立项</el-radio>
											<el-radio v-model="form_setp_2.project_type" label="appraisal">成果鉴定</el-radio>
											<el-radio v-model="form_setp_2.project_type" label="search">一般检索</el-radio>
											<el-radio v-model="form_setp_2.project_type" label="paper_evaluation">论文评估</el-radio>
											<el-radio v-model="form_setp_2.project_type" label="new_evaluation">新技术新项目评估</el-radio>
											<el-radio v-model="form_setp_2.project_type" label="reward">报奖</el-radio>
										</div>
									</el-form-item>
								</el-collapse-item>
								<el-collapse-item title="二、查新创新点及技术要点" name="2">
									<div
										style="background-color: #fcdede;padding:0 15px;color:black;float: left;text-align: left;margin-bottom: 10px;;padding: 20px;width: 100%;">
										<div>1、创新点：委托方自我判断认为具备新颖性的技术要点，表述要求条理明确清晰、用词科学、逻辑严密。①创新点是需要查证的内容要点，要体现查新项目的“新颖性”。一般性的技术特征不适合作为创新点>。②创新点的叙述必须客观明确，每个创新点最好不超过 50 个字（其内容必须要在“科学技术要点”中有详细描述）。③创新点应限制在3个以内，每超过1个，需酌情加收一定费用。<br>2、查新项目的科学技术要点：概要写出项目所属技术领域、背景技术、要解决的技术问题、采用的技术方案、主要技术特征、技术效果及成果应用情况等，此处限100字，详细内容在附件中上传。</div>
									</div>
									<el-form-item label="创新点及技术要点:" prop="science_tech_key_point"  class="custom-label-style">
										<el-input type="textarea" :autosize="{ minRows: 5}" :maxlength="textarea_max_length" show-word-limit placeholder="简洁明了,详细内容可另附一页进行说明" v-model="form_setp_2.science_tech_key_point"></el-input>
									</el-form-item>
								</el-collapse-item>
								<el-collapse-item title="三、参考检索词" name="3">
									<div
										style="background-color: #fcdede;padding:0 15px;color:black;float: left;text-align: left;margin-bottom: 10px;;padding: 20px;">
										<div>
											温馨提示：针对项目查新点和技术要点，提供参考检索词的全称和缩写，国内外查新还需提供英文检索词。例：多发性骨髓瘤（MM）；白细胞介素-6(IL-6)；信号途径。
										</div>
									</div>
									<el-form-item label="检索词:" prop="search_term">
										<el-input v-model="form_setp_2.search_term"></el-input>
									</el-form-item>
								</el-collapse-item>
								<el-collapse-item title="四、参考文献" name="4">
									<div
										style="background-color: #fcdede;padding:0 15px;color:black;float: left;text-align: left;margin-bottom: 10px;;padding: 20px;width: 100%;">
										<div>
											温馨提示：列出与委托项目相关的文献（论文包括作者、题目、刊名、年、卷、期、页等信息，专利包括专利名称、专利号、申请人、申请日期等信息）。
										</div>
									</div>
									<el-form-item label="参考文献:">
										<el-form label-width="100px" class="demo-dynamic">
											<el-form-item v-for="(domain, index) in references" :label="'文献名称' "	:key="domain.key">
												<el-input v-model="domain.value" style="width: 87%;float: left;">
												</el-input>
												<el-button type="danger" @click.prevent="removeDomain(domain)"
													style="float: left">删除
												</el-button>
											</el-form-item>
											<el-form-item>
												<el-button @click="addDomain" style="float: left;">新增文献</el-button>
											</el-form-item>
										</el-form>
									</el-form-item>
								</el-collapse-item>

								<el-collapse-item title="五、附件" name="5">
									<div
										style="background-color: #fcdede;padding:0 15px;color:black;float: left;text-align: left;margin-bottom: 10px;;padding: 20px;width: 100%;">
										<div>
											请上传查新项目科学技术要点详细内容（200-800字）;支持.pdf,.doc,.docx,.xls,.xlsx文件格式;大小5M以内
										</div>
									</div>

									<div v-if='attachment_name==""'>										
										<el-upload ref="upload" drag :action="uploadUrl" :data="{ order_id: order_id }"
											:show-file-list="false" :before-upload="beforeUpload"
											:on-success="onSuccess" :on-error="onError"
											accept=".pdf,.doc,.docx,.xls,.xlsx">
											<i class="el-icon-upload"></i>
											<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>											
										</el-upload>										
									</div>									
									<el-tag v-if="attachment_name!=''">{{attachment_name}}
									</el-tag>
									<el-button v-if="attachment_name!=''" size="mini" type="success" @click="get_file()">下载</el-button>
									<el-button v-if="attachment_name!=''" size="mini" type="danger" @click="delete_file()">删除</el-button>
								</el-collapse-item>
							</el-collapse>

							<el-form-item style="margin-top: 20px">
								<!--修改已支付的订单， 直接跳转到订单列表了-->
								<el-button type="primary" style='margin-left: -95px;' v-if='edit_mode &&pay_date!=""' @click="update_kjcx(turn_to_order_list=true,back_to_previous_page=false,confirm=true)">确认修改</el-button>
								<!--编辑未支付的订单， 还需下一页-->
								<el-button type="primary" v-if='pay_date==""' @click="update_kjcx(turn_to_order_list=false,back_to_previous_page=false,confirm=false)">保存并下一页</el-button>
								<el-button type="" @click="update_kjcx(turn_to_order_list=false,back_to_previous_page=true,confirm=false)">保存并上一页</el-button>
								<el-button type="" @click="update_kjcx(turn_to_order_list=true,back_to_previous_page=false,confirm=false)">保存并退出</el-button>
							</el-form-item>
						</el-form>
					</div>
					<!-- 报告日期及费用 -->
					<div v-if="this.activePage == 2" style="width: 90%;margin:20px auto;padding:5% 1%;background-color: #F0F0F0;overflow: auto;">
						<el-form label-width="100px" class="demo-ruleForm">
							<div style="width:100%;text-align: left;">
								<el-form-item label="项目名称">
									<el-input v-model="form_setp_2.name" disabled></el-input>
								</el-form-item>

								<el-collapse v-model="activeNames">
									<el-collapse-item title="一、报告提交日期" name="1">
										<div
											style="background-color: #fcdede;padding:0 15px;color:black;;padding: 20px;">
											<div>温馨提示，一般情况下，提交申请并完成支付后5个工作日出具报告，特殊情况另行通知：如需加急，请选择提前日期并核对加急费。
											</div>
										</div>
										<el-form-item label="希望出报告日期:" label-width="120px" label-position="top"  style="margin-top: 30px;">
											<el-radio-group v-model="fees_select" size="small" style="margin-top: -10px;" @change="select_fees($event)">
												<el-radio-button v-for="(fees_data, index) in fees_datas" :key="index" :label="fees_data.name" style="margin-right: 20px;">	</el-radio-button>
											</el-radio-group>
											<div style="float:right">
												加急费：<span style="color:red">{{urgent_fees}}元</span>
											</div>
										</el-form-item>
									</el-collapse-item>
									<el-collapse-item title="二、报告相关费用" name="2">
										<div style="background-color: #fcdede;padding:0 15px;color:black;;padding: 20px;">
											<div>温馨提示：仅支持线上自取报告！</div>
										</div>

										<div style="margin-top: 60px;color:black">
											<h5 style="width: 33%;float: left;text-align: center;color:black">
												基础费：<span style="color:orange">{{basic_fees}}元</span>
											</h5>
											<h5 style="width: 33%;float: left;text-align: center;color:black">
												加急费：<span style="color: dodgerblue;">{{urgent_fees}}元</span>
											</h5>
											<h5 style="width: 33%;float: left;text-align: center;color:black">
												总费用：<span style="color:red">{{total_fees}}元</span>
											</h5>
										</div>
									</el-collapse-item>
								</el-collapse>
							</div>							
							<div style="background-color: #fcdede;padding:0 15px;color:black;;padding: 20px;">
								<div>注意：支付成功的订单才能进入审核状态！请选择支付方式并支付：</div>
							</div>
							<el-form-item style="margin-top: 20px;">
								<img src="../assets/wx_pay.jpg" style="cursor: pointer;margin-left: -100px;margin-right: 30px;width: 320px; height: 160px;" @click="processPayment('wxpay', turn_to_order_list=false,back_to_previous_page=false)" alt="微信支付">
								<img src="../assets/ali_pay.jpg" style="cursor: pointer;width: 320px; height: 160px;" @click="processPayment('alipay', turn_to_order_list=false,back_to_previous_page=false)" alt="支付宝支付">								
							</el-form-item>
							<el-form-item style="margin-top: 20px;">
								<el-button style='margin-left: -95px;' @click="processPayment('kjcx', turn_to_order_list=false,back_to_previous_page=true)">保存并上一步</el-button>
								<el-button @click="processPayment('kjcx', turn_to_order_list=true,back_to_previous_page=false)">保存并退出</el-button>
							</el-form-item>
						</el-form>

					</div>
				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>

<script>
	import {fetchGet,fetchPost,} from "../utils/request"
	import {baseURL} from "../utils/baseURL"
	import qs from 'qs'

	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	import {provinceAndCityData,regionData,provinceAndCityDataPlus,regionDataPlus,CodeToText,TextToCode} from 'element-china-area-data'
	export default {
		name: 'user_kjcx',
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,
		},
		data() {
			return {
				uploadUrl: baseURL + '/ro/tec_search/order/file/update/v1', // 文件上传的接口地址				
				file_loading: false,				
				AreaOptions: regionData,
				province: '',
				area: '',
				city: '',
				selectedArea: [],
				ali_pay_img: '',
				payName: '支付',				
				get_pay_state_timer: null,
				order_pay_title: '订单创建成功',
				prompt1: '请在',
				prompt2: '秒内微信扫描二维码支付',
				prompt3: '秒内支付宝扫描二维码支付',
				form_setp_1: {					
					'unit_name': '',
					'address': '',
					'postcode': '',
					'contact': '',
					'contact_mobile': '',
					'contact_phone': '',
					'email': ''
				},
				form_setp_1_rules: {					
					unit_name: [{
						required: true,
						message: '单位名称不能为空',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '地址不能为空',
						trigger: 'blur'
					}],
					contact: [{
						required: true,
						message: '联系人不能为空',
						trigger: 'blur'
					}],
					contact_mobile: [{
						required: true,
						message: '手机不能为空',
						trigger: 'blur'
					}],
					contact_phone: [{
						required: false
					}],
				},
				form_setp_2: {
					name: '',
					en_name: '',
					scope: 'home',
					topic_type: 'national',
					project_type: 'project',
					science_tech_key_point: '',
					search_term: '',
				},
				form_setp_2_rules: {
					name: [{
						required: true,
						message: '项目名称不能为空',
						trigger: 'blur'
					}],
					search_term: [{
						required: true,
						message: '检索词不能为空',
						trigger: 'blur'
					}],
					science_tech_key_point: [{
						required: true,
						message: '研究内容不能为空',
						trigger: 'blur'
					}],
					project_type: [{
						required: true,
						message: '项目类型不能为空',
						trigger: 'blur'
					}],
					topic_type: [{
						required: true,
						message: '课题级别不能为空',
						trigger: 'blur'
					}],
					scope: [{
						required: true,
						message: '查新范围不能为空',
						trigger: 'blur'
					}],
				},
				selected_page: '2-1',
				activePage: 0,//当前页码
				textarea_max_length: 200,

				address_selected: '',				
				activeNames: ['1', '2', '3', '4', '5'],
				address_datas: [],
				select_date: '',
				references: [],
				dialogVisible: false,
				wxpay_dialogVisible: false,
				alipay_dialogVisible: false,
				loading: false,//用于显示支付二维码加载效果
				paying: false,
				wx_pay_img: 'https://p2.itc.cn/images01/20211001/f2b77a3dd20f4be88cd84a9d659fa1cb.jpeg',
				order_id: 0,
				fees_datas: [],
				fees_select: '',
				basic_fees: 0,
				total_fees: 0,
				urgent_fees: 0,
				edit_mode: false, //判定是否是 从编辑订单过来的
				state: 'edit', //默认就是编辑中draft，如果 审核没通过，那就是 eidt，此时还要显示未通过原因。
				approval_note: '', //默认就是编辑中draft，如果 审核没通过，那就是 eidt，此时还要显示未通过原因。
				attachment_name: false,
				attachment_url: false,
				pay_date: '', //判断是否支付过
				countdown: 60, // 倒计时初始值
				countdownTimer: null, // 用于保存倒计时定时器的引用
				payment_status: null, // 用于保存支付状态 null:未支付  success:支付成功
			}
		},
		mounted() {
			var self = this
			var id = this.$route.query.id
			// debugger
			if (id != undefined) {
				this.get_order_info(id)
			}
			this.get_address_data()
			this.get_tech_order_point_limit()
		},		
		methods: {
			generateCommonData(extraData = {}) {
				const commonData = {
					id: this.order_id,
					info_id: this.address_selected,
					province: this.province,
					city: this.city,
					area: this.area,
					references: JSON.stringify(this.references),
					name: this.form_setp_2.name,
					en_name: this.form_setp_2.en_name,
					unit_name: this.form_setp_1.unit_name,
					address: this.form_setp_1.address,
					email: this.form_setp_1.email,
					postcode: this.form_setp_1.postcode,
					contact: this.form_setp_1.contact,
					contact_phone: this.form_setp_1.contact_phone,
					contact_mobile: this.form_setp_1.contact_mobile,
					scope: this.form_setp_2.scope,
					topic_type: this.form_setp_2.topic_type,
					project_type: this.form_setp_2.project_type,
					science_tech_key_point: this.form_setp_2.science_tech_key_point,
					search_term: this.form_setp_2.search_term,
					user_id: window.localStorage.getItem('user_id'),
					type: 'tech'
				};

				return { ...commonData, ...extraData };
			},
			beforeUpload(file) {
				this.file_loading = true
				// console.log('上传文件')
				// 在这里可以进行文件大小、类型等的验证
				// 返回 false 可以阻止文件上传
			},

			onSuccess(response, file, fileList) {
				// 上传成功的处理逻辑
				// debugger
				this.attachment_name = response.attachment_name
				this.attachment_url = response.attachment_url
				this.file_loading = false

			},
			onError(error, file, fileList) {
				// 上传失败的处理逻辑
			},

			get_order_info(id) {
			  this.order_id = id;
			  this.edit_mode = true;
			  
			  const data = { id };
			
			  fetchPost('/ro/tec_search/order/detail/v1', data).then(response => {
			    console.log('=------data------');
			    console.log(response.data.data);
			    
			    const order_data = response.data.data;
			    const { 
			      name, en_name, unit_name, address, email, postcode, contact, 
			      contact_phone, contact_mobile, scope, topic_type, project_type, 
			      science_tech_key_point, search_term, attachment_name, attachment_url, 
			      pay_date, reference_ids, province, city, area 
			    } = order_data;
			
			    this.id = order_data.id;
			    this.approval_note = order_data.approval_note;
			    this.state = order_data.state;
			    this.form_setp_2 = { name, en_name, scope, topic_type, project_type, science_tech_key_point, search_term };
			    this.form_setp_1 = { unit_name, address, email, postcode, contact, contact_phone, contact_mobile };
			    this.attachment_name = attachment_name;
			    this.attachment_url = attachment_url;
			    this.pay_date = pay_date;
			    this.references = reference_ids;
			    this.type = 'tech';
			
			    const selectedProvince = TextToCode[province].code;
			    const selectedCity = TextToCode[province][city].code;
			    const selectedArea = TextToCode[province][city][area].code;
			
			    this.address_selected = order_data.info_id;
			    this.province = province;
			    this.city = city;
			    this.area = area;
			    this.selectedArea = [selectedProvince, selectedCity, selectedArea];
			  });
			},
			handleChangeArea(value) {
				this.province = CodeToText[value[0]]
				this.city = CodeToText[value[1]]
				this.area = CodeToText[value[2]]
				console.log(this.province)
				console.log(this.city)
				console.log(this.area)
			},
			//科技查新描述字数限制
			get_tech_order_point_limit() {				
				fetchPost('/ro/tec_search/order/get_order_point_limit/v1', {}).then(response => {
					this.textarea_max_length = response.data.tech_order_point_limit
				})
			},
			delete_file() {
				console.log('delete_file')
				const data = {
					'id': this.order_id,
				};
				
				fetchPost('/ro/tec_search/order/delete/file/v1', data).then(response => {
					if (response.data.result === 'session_expired') {
						window.location.href = '/#/pages/login';
					}
					this.attachment_name = ''
					this.attachment_url = ''
				})
			},
			get_file() {
				console.log(this.attachment_url)
				window.open(this.attachment_url, "_blank")
			},
			turn_to_new_info() {
				this.$router.push('/user/new_infor')
			},
			get_fees_data() {
			  const data = {
			    id: this.order_id,
			    type: 'tech',
			    scope: this.form_setp_2.scope
			  };
			
			  fetchPost('/ro/tec_search/order/get_fees/v1', data).then(response => {
			    this.fees_datas = response.data;
			    const last = response.data.length - 1;
			    const { name, basic_fees, urgent_fees, total_fees, expected_report_time } = response.data[last];
			
			    this.fees_select = name;
			    this.basic_fees = parseFloat(basic_fees).toFixed(2);
			    this.urgent_fees = parseFloat(urgent_fees).toFixed(2);
			    this.total_fees = parseFloat(total_fees).toFixed(2);
			    this.expected_report_time = expected_report_time;
			  });
			},
			turn_to_order_info() {

				this.$router.push('/user/order')
			},
			stop_pay_state_timer() {
			  if (this.get_pay_state_timer) {
				console.log("删除get_pay_state_timer定时器！");
				clearInterval(this.get_pay_state_timer);
				this.get_pay_state_timer = null;  // 手动将 self.get_pay_state_timer 设置为 null
			  }
			},
			stop_countdownTimer() {
			  // 清除倒计时定时器
			  if (this.countdownTimer) {
			  	console.log("删除countdownTimer倒计时定时器！");
			  	clearInterval(this.countdownTimer);
				this.countdownTimer = null;
			  }
			},
			handleClose() {
				this.stop_pay_state_timer()
				this.stop_countdownTimer()				
				this.wxpay_dialogVisible = false
				this.alipay_dialogVisible = false
				this.countdown = 60
				if(this.payment_status == "success")
				{
					this.turn_to_invoice();
					this.payment_status = null;
					this.prompt1 = '请在';
					this.prompt2 = '秒内微信扫描二维码支付';
					this.prompt3 = '秒内支付宝扫描二维码支付';
				}
			},
			turn_to_invoice() {
				window.location.href='#/user/invoice?id='+this.order_id+'&total_fees='+this.total_fees				
			},
			get_pay_state() {
				var self = this
				var data = {
					'id': this.order_id
				}				
				fetchPost('/ro/tec_search/order/get_payment_state/v1', data).then(response => {
					console.log(response.data)
					if (response.data.result == 'success') {
						self.order_pay_title = '订单支付完成,5s后将自动跳转'
						this.stop_pay_state_timer()						
						//等待10秒弹出开发票页面
						setTimeout(function() {
							self.turn_to_invoice()
						}, 10000)
						this.payment_status = "success";
						this.countdown = 5;
						this.prompt1 = '本页面将在';
						this.prompt2 = '秒后自动退出！';
						this.prompt3 = '秒后自动退出！';
						this.wx_pay_img = require('../assets/payment_success.png');
						this.ali_pay_img = '/alipay_success_image.html'						
					}
				})
			},
			startCountdown() {
				this.countdownTimer = setInterval(() => {
					if (this.countdown > 0) {
						this.countdown--;
						console.log(this.countdown);
					} else {						
						this.handleClose(); // 倒计时结束时调用 handleClose						
					}
				}, 1000);
			},			
			ali_pay() {				
				this.ali_pay_img = baseURL + '/ro/connector/alipay/ali_pay/v1?order_id=' + this.order_id+'&date='+Date.now();
				console.log('user_kjcx 700行，this.ali_pay_img = ' + this.ali_pay_img)
				setTimeout(() => {  
				        // 这里是等待3秒后执行的代码  
				        console.log('已经等待了3秒');  
				        // 你可以在这里调用其他方法或执行其他操作  
						this.loading = false
						console.log('user_kjcx 706行，this.loading = ' + this.loading)
						console.log('user_kjcx 707行，this.ali_pay_img = ' + this.ali_pay_img)
				}, 3000); // 3000毫秒 = 3秒  				
				console.log('user_kjcx 710行，this.loading = ' + this.loading)
				this.paying = true
				
				if (!this.get_pay_state_timer) {
					console.log('新建 get_pay_state_timer')					
					this.get_pay_state_timer = setInterval(() => {
						console.log('循环查询订单支付情况')
						this.get_pay_state()
					}, 1000)
				}
			},
			wx_pay() {
				// debugger
				var data = {
					'order_id': this.order_id,
				}				
				fetchPost('/ro/connector/wx/wx_pay_native/v1', data).then(response => {
					console.log(response.data)
					this.wx_pay_img = response.data //获得的微信支付二维码
					this.loading = false
					this.paying = true
					
					if (this.get_pay_state_timer == null) {
						console.log('新建 get_pay_state_timer')						
						this.get_pay_state_timer = setInterval(() => {
							console.log('循环查询订单支付情况')
							this.get_pay_state()
						}, 1000)
						// debugger						
					}
				})
			},	
			handleResponse(response, turn_to_order_list, back_to_previous_page) {
				if (response.data.result === 'session_expired') {
					window.location.href = '/#/pages/login';
					return;
				}
				if (!turn_to_order_list) {
					if (back_to_previous_page) {
						this.activePage -= 1;
					}			
				} else {					
					this.$router.push(this.pay_date === '' ? "/user/order?type=未提交" : "/user/order");
				}
				this.scrollToTop();
			},
			// 在 JavaScript 中，self 和 this 之间的区别主要在于它们的上下文。在一些异步回调函数中，例如在 fetchPost 的 .then 方法中，this 的上下文会发生变化，
			// 指向调用它的函数或对象，而不是外部的 Vue 组件实例。为了解决这个问题，通常会使用 self 变量将外部上下文中的 this 存储起来，然后在回调函数中使用
			//  self 来引用外部的 Vue 组件实例。			
			// 为了简化和优化代码，我们可以使用箭头函数，因为箭头函数不会创建自己的 this，它会捕获外层的 this 值。这样就不需要 self 变量了。
			// 在 fetchPost 的 .then 方法中使用箭头函数，确保 this 指向外层的 Vue 组件实例，从而省去了使用 self 的必要。
			processPayment(type,turn_to_order_list, back_to_previous_page, extraData = {}) {
				const data = this.generateCommonData({
					total_fees: this.total_fees,
					urgent_fees: this.urgent_fees,
					basic_fees: this.basic_fees,
					expected_report_time: this.expected_report_time,
					confirm: false,
					finish: true
				});
				fetchPost('/ro/tec_search/order/update/v1', data).then(response => {
					this.handleResponse(response, turn_to_order_list, back_to_previous_page);
					if (!turn_to_order_list && !back_to_previous_page) {
						if (type === 'wxpay') {
							this.wxpay_dialogVisible = true;							
							this.wx_pay();
						} else if (type === 'alipay') {
							this.alipay_dialogVisible = true;							
							this.ali_pay();
						}
						this.loading = true;
						this.startCountdown();
					}
				});
			},
			handleResponse1(response, turn_to_order_list, back_to_previous_page) {
			    if (response.data.result === 'session_expired') {
			      window.location.href = '/#/pages/login';
			      return;
			    }
			    if (!turn_to_order_list) {
			      if (back_to_previous_page) {
			        this.activePage -= 1;
			      } else {
			        this.activePage += 1;
			      }			      
			    } else {			
				  this.$router.push(this.pay_date === '' ? "/user/order?type=未提交" : "/user/order");			      
			    }
				this.scrollToTop();
			    this.get_fees_data();
			},
			update_kjcx(turn_to_order_list, back_to_previous_page, confirm) {				
				const data = this.generateCommonData({
					confirm: confirm
				});				
				// debugger
				this.$refs.form_setp_2.validate(valid => {
					if (valid) {
						data['edit_mode'] = 'no'
						fetchPost('/ro/tec_search/order/update/v1', data).then(response => {
							this.handleResponse1(response, turn_to_order_list, back_to_previous_page)							
						});						
					} else {
						this.$message.error('请完善必填字段')
					}
				})
			},
			
			handleUploadForm(param) {
				const reader = new FileReader();
				const file_name = param.file.name;
				reader.readAsDataURL(param.file);// 把目标文件转地址，文件来自于上传组件。
				
				 reader.onload = () => { // 文件读取成功时触发					
					const data = {
						'id': this.order_id,
						'file_name': file_name,
						'file': reader.result
					};
					
					console.log(data);
					fetchPost('/ro/tec_search/order/file/update/v1', data).then(response => {
						this.attachment_name = file_name;
						this.attachment_url = response.data;
						const { turn_to_order_list, back_to_previous_page, confirm } = this;
						this.update_kjcx(turn_to_order_list, back_to_previous_page, confirm);
					});
				};
			},
			create_kjcx(next = false) {
			    if (this.order_id === 0) {
			      this.createNewOrder(next);
			    } else {
			      this.updateExistingOrder(next);
			    }
			},
			createNewOrder(next) {
				const data = {
				  info_id: this.address_selected,
				  province: this.province,
				  city: this.city,
				  area: this.area,
				  unit_name: this.form_setp_1.unit_name,
				  address: this.form_setp_1.address,
				  email: this.form_setp_1.email,
				  postcode: this.form_setp_1.postcode,
				  contact: this.form_setp_1.contact,
				  contact_phone: this.form_setp_1.contact_phone,
				  contact_mobile: this.form_setp_1.contact_mobile,
				  user_id: window.localStorage.getItem('user_id'),
				  type: 'tech'
				};

				console.log(data);
				this.$refs.form_setp_1.validate(valid => {
				  if (valid) {
					fetchPost('/ro/tec_search/order/create/v1', data).then(response => {
					  if (response.data.result === 'session_expired') {
						window.location.href = '/#/pages/login';
					  }
					  this.order_id = response.data.id;
					  this.handlePostOrderCreation(next);
					});
				  } else {
					this.$message.error('请完善必填字段');
				  }
				});
			},

			updateExistingOrder(next) {
				const data = this.generateCommonData({
				  confirm: false,
				  edit_mode: 'yes'
				});

				fetchPost('/ro/tec_search/order/update/v1', data).then(response => {
				  if (response.data.result === 'session_expired') {
					window.location.href = '/#/pages/login';
				  }
				  this.handlePostOrderCreation(next);
				  this.get_fees_data();
				});
			},
			handlePostOrderCreation(next) {
				if (next) {
				  this.activePage += 1;
				} else {
				  this.$router.push(this.pay_date === '' ? "/user/order?type=未提交" : "/user/order");
				}
				this.scrollToTop();
			},
			select_account(e) {
				var id = e
				var select_account_data = this.account_datas.filter(item => item.id == id)[0]
				console.log(select_account_data)
				this.account_unit_name = select_account_data.unit_name
				this.account_tax_number = select_account_data.tax_number
			},
			select_fees(e) {
				var select_fees = this.fees_datas.filter(item => item.name == e)[0]
				// debugger
				this.basic_fees = parseFloat(select_fees.basic_fees).toFixed(2)
				this.urgent_fees = parseFloat(select_fees.urgent_fees).toFixed(2)
				this.total_fees = parseFloat(select_fees.total_fees).toFixed(2)
				this.expected_report_time = select_fees.expected_report_time
			},
			assignAddressData(select_address_data) {
			    this.form_setp_1.unit_name = select_address_data.unit_name;
			    this.form_setp_1.postcode = select_address_data.postcode;
			    this.form_setp_1.address = select_address_data.address;
			    this.form_setp_1.email = select_address_data.email;
			    this.form_setp_1.contact = select_address_data.contact;
			    this.form_setp_1.contact_phone = select_address_data.contact_phone;
			    this.form_setp_1.contact_mobile = select_address_data.contact_mobile;
			    
			    this.province = select_address_data.province;
			    this.city = select_address_data.city;
			    this.area = select_address_data.area;
			
			    const province = TextToCode[select_address_data.province].code;
			    const city = TextToCode[select_address_data.province][select_address_data.city].code;
			    const area = TextToCode[select_address_data.province][select_address_data.city][select_address_data.area].code;
			
			    this.selectedArea = [province, city, area];
			},
			
			set_default_address() {
			    const select_address_data = this.address_datas.find(item => item.default === true);
			    
			    if (select_address_data) {
			      this.assignAddressData(select_address_data);
			      this.address_selected = select_address_data.id;
			    } else {
			      console.error("No default address found.");
			    }
			},			
			select_address(e) {
			    const select_address_data = this.address_datas.find(item => item.id === e);
			    
			    if (select_address_data) {
			      this.assignAddressData(select_address_data);
			      this.address_selected = select_address_data.id;
			    } else {
			      console.error("Address not found.");
			    }
			},
			get_address_data() {
			  const data = {
			    id: window.localStorage.getItem('user_id')
			  };
			  fetchPost('/ro/tec_search/user/info/list/v1', data).then(response => {
			    this.address_datas = response.data.list;
			    console.log(this.order_id);
			    if (this.order_id == 0) {
			      this.set_default_address();
			    }
			  });
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			},

			before() {
				if (this.active-- < 1) this.activePage = 0;
				console.log(this.activePage)
				this.scrollToTop()
			},

			// 新增文献
			removeDomain(item) {
				var index = this.references.indexOf(item)
				if (index !== -1) {
					this.references.splice(index, 1)
				}
			},
			addDomain() {
				this.references.push({
					key: Date.now()
				});
			},

			tabClick(row, column, cell, event) {
				switch (column.label) {
					case '顺序':
						this.tabClickIndex = row.index
						this.tabClickLabel = column.label
						break
					default:
						return
				}
				console.log('tabClick', this.tabClickIndex, row.adName, row.adSort)
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				// 把每一行的索引放进row
				row.index = rowIndex
			},
			check_data() {
				var self = this;
				// 产品数据
				// var product_ids = this.product_ids
				// 客户
				var customer_id = this.customer_id
				// 查询数据
				// debugger;
				var postdata = {
					// 'product_ids': product_ids.join(','),
					'customer_id': customer_id,
				}
				// debugger;
				fetchPost('/ro/report_data_center/cost/datas/check', postdata, ).then(function(data) {

					self.tableData = data.data['product_data']

				})
			},
			beforeDestroy() {
			    this.stop_pay_state_timer();  // 确保在组件销毁时清除定时器
				// 清除倒计时定时器
				if (this.countdownTimer) {
					clearInterval(this.countdownTimer);
					this.countdownTimer = null;
				}
				if (this.get_pay_state_timer) {
					clearInterval(this.get_pay_state_timer);
					this.get_pay_state_timer = null; // 可选，清除引用
				}
			}
		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	.el-step__main {
		text-align: center;
	}

	.ro-address-radio {
		width: 31%;
		white-space: normal;
		height: 100px !important;
		float: left;
		text-align: left;
		border: 2px solid #cdcdcd !important;
		margin-left: 1% !important;
		margin-right: 1% !important;
	}

	.el-form-item__label {
		color: #333333;
		font-weight: 500;
	}

	.ro-box-content {
		border-top: 2px solid #cdcdcd;
		margin-top: 8px;
		padding-top: 8px;
		line-height: 20px;
	}

	.el-step.is-simple .el-step__icon {
		margin-top: 10px;
	}

	.el-collapse-item__header {
		background-color: #cdcdcd;
		border-radius: 3px;
		height: 35px;
		padding: 0 10px;
		font-weight: 800;
	}

	.el-collapse-item__wrap {
		background-color: #F0F0F0;
		padding: 10px;
		font-weight: 800;
		padding-bottom: 0px !important;
	}

	.el-result {
		padding-top: 0px;
		padding-bottom: 0px;
	}

	.el-textarea .el-input__count {
		background-color: transparent;
		bottom: -27px;
	}

	.el-radio__input.is-checked+.el-radio__label {
		color: #ff0000;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: #ff0000;
		background: #ff0000;
	}

	.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
		box-shadow: 0 0 2px 2px #ff0000;
	}

        .custom-label-style .el-form-item__label {
	  display: flex;
	  align-items: center;
	  line-height: 1.5; /* 调整行间距，可以根据需要设置合适的值 */
	}
</style>
